export default __webpack_public_path__ + "static/media/unkown.90c9f816.jpg";